import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LorenDashboardComponent } from "./components/loren-dashboard/loren-dashboard.component";

const routes: Routes = [
  {
    path: "",
    component: LorenDashboardComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LorenDashboardRoutingModule {}
